import { ref } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'
import EventBus from '@/store/EventBus'

export default function usePublishNominations({ runGated } = {}) {
  const publishing = ref(false)

  async function publish(id) {
    publishing.value = true
    try {
      const call = () => draftApi.publishNominations(id)
      await (runGated ? runGated(call) : call())
      return true
    } catch (err) {
      if (!err.isGateCancelled) {
        const data = err.response != null ? err.response.data : null
        const msg = data != null && data.message != null
          ? data.message
          : 'A server error occurred. Please try again later.'
        EventBus.$emit('http-error', msg)
      }
      return false
    } finally {
      publishing.value = false
    }
  }

  return { publish, publishing }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/usePublishNominations.js